import imageUrlBuilder from "@sanity/image-url";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import Image from "next/image";

import { Button, Text } from "@/components/elements";
import useBreakpointTest from "@/hooks/useBreakpointTest";
import { client } from "@/sanity/lib/client";

import styles from "./styles.module.css";

export type HeroBannerProps = {
  content: {
    hero_image: SanityImageSource;
    hero_image_alt: string;
    mobile_hero_image: SanityImageSource;
    mobile_hero_image_alt: string;
    hero_payoff: string;
    hero_cta_text: string;
    hero_cta_url: string;
  };
  locale?: string;
};

export const HeroBanner = ({ content }: HeroBannerProps) => {
  const isTablet = useBreakpointTest("sm");
  // Sanity image builder
  const builder = imageUrlBuilder(client());
  function urlFor(source) {
    return builder.image(source);
  }

  return (
    <div className={styles.container}>
      <div className={styles.copy}>
        <Text as="h1" size="xxl" className={styles.heading}>
          {content.hero_payoff}
        </Text>
        {/* TODO: This should be an <a> */}
        <Button
          theme="green"
          onClick={() => {
            window.location.href = content.hero_cta_url;
          }}
        >
          {content.hero_cta_text}
        </Button>
      </div>
      <Image
        src={
          isTablet
            ? urlFor(content.hero_image).url()
            : urlFor(content.mobile_hero_image).url()
        }
        alt={isTablet ? content.hero_image_alt : content.mobile_hero_image_alt}
        priority
        fill
        className={styles.image}
      />
    </div>
  );
};
